module.exports = __webpack_public_path__ + "static/media/benedict-2.5f0056ce.jpg";